export const teamTypes = {
  REGISTER: 'team/REGISTER',
  REG_RESPONSE: 'team/REGISTER_RESPONSE',
  REG_SUCCESS: 'team/REG_SUCCESS',
  GET_MINE: 'team/GET_MINE',
  GET_MINE_RESPONSE: 'team/GET_MINE_RESPONSE',
  SAVE_MINE: 'team/SAVE_MINE',
  SAVE_TEAMS: 'team/SAVE_TEAMS',
  UPDATE: 'team/UPDATE',
  MANAGE: 'team/MANAGE_MINE',
  MANAGE_RES: 'team/MANAGE_RESPONSE',
  GET_SINGLE: 'team/GET_SINGLE',
  GET_SINGLE_RES: 'team/GET_SINGLE_RES',
  GET_ALL: 'team/GET_ALL',
  GET_ALL_RESPONSE: 'team/GET_ALL_RESPONSE',
  JOIN: 'team/JOIN',
  JOIN_RESPONSE: 'team/JOIN_RESPONSE',
  DELETE: 'team/DELETE',
  DELETE_RESPONSE: 'team/DELETE_RESPONSE',
  CHANGE_STATUS: 'team/CHANGE_STATUS',
  CHANGE_STATUS_RES: 'team/CHANGE_STATUS_RESPONSE',
  CHANGE_LOCATION: 'team/CHANGE_LOCATION',
  CHANGE_LOCATION_RES: 'team/CHANGE_LOCATION_RES',
  CHANGE_COMMENT: 'team/CHANGE_COMMENT',
  CHANGE_COMMENT_RES: 'team/CHANGE_COMMENT_RESPONSE',
  REMOVE: 'team/REMOVE_FROM_LOADED'
}

export const teamRegister = (data) => (
  {
    type: teamTypes.REGISTER,
    data
  }
)

export const teamManage = (data) => (
  {
    type: teamTypes.MANAGE,
    data
  }
)

export const getMyTeam = (data) => (
  {
    type: teamTypes.GET_MINE
  }
)

export const getTeams = () => (
  {
    type: teamTypes.GET_ALL
  }
)

export const getTeam = (id) => (
  {
    type: teamTypes.GET_SINGLE,
    id
  }
)

export const joinTeam = (id) => (
  {
    type: teamTypes.JOIN,
    id
  }
)

export const deleteTeam = (id) => (
  {
    type: teamTypes.DELETE,
    id
  }
)

export const changeTeamStatus = (data) => (
  {
    type: teamTypes.CHANGE_STATUS,
    data
  }
)

export const changeTeamLocation = (data) => (
  {
    type: teamTypes.CHANGE_LOCATION,
    data
  }
)

export const removeTeamFromLoaded = (id) => (
  {
    type: teamTypes.REMOVE,
    id
  }
)

export const changeTeamComment = (data) => (
  {
    type: teamTypes.CHANGE_COMMENT,
    data
  }
)



// WEBPACK FOOTER //
// ./src/actions/team.js